module.exports = __webpack_public_path__ + "static/media/calendar-dull.5cefe283.svg";